import { checkShouldUseMocks } from '@telialt/utils/src/envUtils';
import { MS_URL } from '@telialt/utils/src/microservices';

export const LOCAL_MESSAGES_BASE_URL = 'http://localhost:3001';

export const shouldUseLocalMessages = () => process.env.USE_LOCAL_MESSAGES === 'true';

export const Types = {
    CONTENT: {
        SLOTS: {
            REQUEST: 'CONTENT.SLOTS.REQUEST',
        },
        SLOT: {
            REQUEST: 'CONTENT.SLOT.REQUEST',
            RECEIVE: 'CONTENT.SLOT.RECEIVE',
            ERROR: 'CONTENT.SLOT.ERROR',
        },
    },
    COMPONENT: {
        DATA: {
            REQUEST: 'COMPONENT.DATA.REQUEST',
            RECEIVE: 'COMPONENT.DATA.RECEIVE',
            ERROR: 'COMPONENT.DATA.ERROR',
        },
    },
    MESSAGES: {
        REQUEST: 'MESSAGES.REQUEST',
        RECEIVE: 'MESSAGES.RECEIVE',
        ERROR: 'MESSAGES.ERROR',
    },
};

export const API = {
    URL_CONTENT_SLOT: `/rest/v2/teliaWebsite/{segment}/cms/slots/{contentSlotId}/components`,
    URL_FAQ_WIDGET: `/view/FaqContextualComponentController/data`,
    URL_MESSAGES: shouldUseLocalMessages()
        ? `${LOCAL_MESSAGES_BASE_URL}/api/messages`
        : `${MS_URL}/api/v3/content/messages`,
};

if (checkShouldUseMocks({ shouldUseInTest: true })) {
    API.URL_CONTENT_SLOT = '/api/cms/{segment}/{contentSlotId}';
    API.URL_FAQ_WIDGET = '/api/faq/faq-widget';
    API.URL_MESSAGES = '/api/messages';
}

export const MESSAGES_QUERY_KEY = 'MESSAGES';
